
import React from "react";

export const SucessStories = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-krem py-10 px-4 mt-20 md:mt-14">
      <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold text-Narandzasta mb-6 text-center">Emisija: Putevi zdravlja</h1>
      <div className="w-full max-w-4xl aspect-video mb-6 shadow-lg rounded-lg overflow-hidden">
        <iframe
          className="w-full h-full"
          src="https://www.youtube.com/embed/tn075lHXi3M"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="max-w-4xl bg-white p-6 rounded-lg shadow text-gray-700">
        <h2 className="text-2xl mb-2 font-light font-poppins">Moždani udar - edukativna emisija</h2>
        <p>
          U ovoj emisiji, naš ordinarius vodi temu o moždanom udaru, njegovim uzrocima, simptomima i mogućnostima liječenja. Saznajte više o važnosti pravovremene reakcije, rehabilitaciji i podršci pacijentima i njihovim porodicama. Edukacija i informisanost su ključni za prevenciju i uspješno liječenje moždanog udara.
        </p>
      </div>
      {/* Ramo section*/}
      <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold text-Narandzasta mb-6 text-center mt-5">Ramo Midžić  </h1>
      <div className="w-full max-w-4xl aspect-video mb-6 shadow-lg rounded-lg overflow-hidden">
        <iframe
          className="w-full h-full"
          src="https://www.youtube.com/embed/RD4GE4AfGZs"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="max-w-4xl bg-white p-6 rounded-lg shadow text-gray-700">
        <h2 className="text-2xl mb-2 font-light font-poppins">Rehabilitacija našeg Rame</h2>
        <p>

          Gospodin Ramo Midžić dolazu u Ustanovu Familia nakon operacije meningeoma torakalne regije. Kako navodi imao je još dvije operacije na kičmi, dijagnosticirana mu je paraplegija i već je devet mjeseci nepokretan.<br />
          Kroz fizikalnu terapiju dva puta dnevno provođene su:<br />
          Kineziterapija - extenzomat,<br />
          Pasivne i aktivno potpomognute vježbe,<br />
          Izokinetička mjerenja,<br />
          Robotska rehabilitacija - Izokinetička terapija - Biodex PRO 4,<br />
          Vertikalizacija na oscilatornom stolu,<br />
          Vježbe na suspenzionom aparatu
        </p>
      </div>
      {/* Zlata section*/}
      <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold text-Narandzasta mb-6 text-center mt-5">Zlata Nosse  </h1>
      <div className="w-full max-w-4xl aspect-video mb-6 shadow-lg rounded-lg overflow-hidden">
        <iframe
          className="w-full h-full"
          src="https://youtube.com/embed/Dt8a2cQipME"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="max-w-4xl bg-white p-6 rounded-lg shadow text-gray-700">
        <h2 className="text-2xl mb-2 font-light font-poppins">Emotivna priča</h2>
        <p>CESTITKE teta Zlati i cijelom timu na izuzetno brzom oporavku i rehabilitaciji  -  sretan put nazad u Zagreb !!! Pogledajte kratku emotivnu priču
        </p>
      </div>
      {/* 3 uspjesne rehabilitacije*/}
      <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold text-Narandzasta mb-6 text-center mt-5">Još tri uspješne rehabilitacije !!!</h1>
      <div className="w-full max-w-4xl aspect-video mb-6 shadow-lg rounded-lg overflow-hidden">
        <iframe
          className="w-full h-full"
          src="https://youtube.com/embed/BAHWDgVi4OY"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="max-w-4xl bg-white p-6 rounded-lg shadow text-gray-700">
        <h2 className="text-2xl mb-2 font-light font-poppins">Uspješne rehabilitacije</h2>
        <p>Čestitke na uspješnoj rehabilitaciji troje pacijenata! Njihova upornost i snaga zaista su inspirativne.

          Velike čestitke upućujemo i cijelom timu, čija je posvećenost bila ključna za ovaj rezultat. Ovo je sjajan dokaz da se trud i predan rad uvijek isplate.

          Sada, idemo dalje ka novim uspjesima!
        </p>
      </div>
      {/* Sekcija Nermin */}
      <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold text-Narandzasta mb-6 text-center mt-5">SRETNO NERMINE !!!</h1>
      <div className="w-full max-w-4xl aspect-video mb-6 shadow-lg rounded-lg overflow-hidden">
        <iframe
          className="w-full h-full"
          src="https://youtube.com/embed/PFSvxeS91gs"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="max-w-4xl bg-white p-6 rounded-lg shadow text-gray-700">
        <h2 className="text-2xl mb-2 font-light font-poppins">Uspješne rehabilitacije</h2>
        <p>Nakon moždanog udara,  par mjeseci boravka u našoj ustanovi, uz puno puno truda i rada, Nermin skoro sasvim samostalno odlazi kući!
          Veliki uspjeh cijelog tima, i još jednom  - BRAVO Nermine !!
        </p>
      </div>
      {/* Sekcija Alma */}
      <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold text-Narandzasta mb-6 text-center mt-5">Alma rehabilitacija</h1>
      <div className="w-full max-w-4xl aspect-video mb-6 shadow-lg rounded-lg overflow-hidden">
        <iframe
          className="w-full h-full"
          src="https://youtube.com/embed/zBb-mccyazI"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="max-w-4xl bg-white p-6 rounded-lg shadow text-gray-700">
        <h2 className="text-2xl mb-2 font-light font-poppins">Pogledajte kratki video o uspješnoj rehabilitaciji naše drage Alme</h2>
        <p>Još jedna inspirativna priča koja pokazuje koliko se može postići uz pravi pristup i podršku! 🌟
🎥 Kliknite i uvjerite se sami!
        </p>
      </div>
    </div>
  );
};
